import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Modal, RecordsTable, USER_PERMISSIONS } from 'dyl-components';

import OpportunitiesHeader from './Header';
import OpportunitiesRow from './OpportunitiesRow';
import AddOpportunityModal from 'shared/modals/AddOpportunityModal';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import "../index.scss"
import SequenceModal from 'shared/modals/SequenceModal';
import QuoteBuilderProvider from 'shared/context/QuoteBuilderProvider';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';

const OpportunitiesTable = ({ onFilter, isColumnHidden, onPageChange }) => {
    const [params] = useSearchParams();

    const { count, opportunities = [], isReadingOpportunities } = useSelector(state => state.opportunities);

    const [isAddOpportunityModalOpen, setIsAddOpporunityModalOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [selectedOpportunity, setSelectedOpportunity] = useState(null);
    const [modalRef, setModalRef] = useState(null);
    const onOpenAddOpportunityModal = () => {
        setIsAddOpporunityModalOpen(true);
    }

    const onCloseAddOpportunityModal = () => {
        setIsAddOpporunityModalOpen(false);
    }

    const [opportunityBeingConverted, setOpportunityBeingConverted] = useState(null);

    const onSelectOpportunityForConversion = (id) => {
        setOpportunityBeingConverted(id);
    }

    const detailsOfOpportunityBeingConverted = opportunities.find(opportunity => opportunity.pipeline_id === opportunityBeingConverted);

    return (
        <React.Fragment>
            <QuoteBuilderProvider>
                <RecordsTable
                    tableBodyClassName='OpportunityTable'
                    isTableLoading={isReadingOpportunities}
                    isSearchResultEmpty={count === 0 && (params.has('search') || params.has('start') || params.has('end') || params.has('account_type') || params.has('owned_by'))}
                    isTableEmpty={!count && !(params.has('search') || params.has('start') || params.has('end') || params.has('account_type') || params.has('owned_by'))}
                    TableHeader={<OpportunitiesHeader isColumnHidden={isColumnHidden} onFilter={onFilter} />}
                    TableRows={opportunities.map(opportunity => (
                        <OpportunitiesRow
                            key={opportunity.pipeline_id}
                            opportunity={{...opportunity,contact_id:opportunity?.contact?.id}}
                            isColumnHidden={isColumnHidden}
                            setSelectedOpportunity={setSelectedOpportunity}
                            setModalRef={setModalRef}
                            onSelectOpportunityForConversion={() => {onSelectOpportunityForConversion(opportunity.pipeline_id)}}
                        />
                    ))}
                    recordsCount={count}
                    activePage={params.get('page')}
                    onPageChange={onPageChange}
                    recordsName='Opportunity'
                    onClick={onOpenAddOpportunityModal}
                    userPermission={USER_PERMISSIONS.OPPORTUNITY_ADD}
            />
                <QuoteBuilderModal
                    account_id={detailsOfOpportunityBeingConverted?.account?.id}
                    opportunity_id={detailsOfOpportunityBeingConverted?.pipeline_id}
                    contact_id={detailsOfOpportunityBeingConverted?.contact?.id}
                    isLinkedToCustomer={detailsOfOpportunityBeingConverted?.account?.customer}
                />
            </QuoteBuilderProvider>
            <Modal open={isAddOpportunityModalOpen} onClose={() => {
                isDirty
                    ? setIsConfirmationOpen(true)
                    : onCloseAddOpportunityModal();
            }}>
                <AddOpportunityModal onOpen={() => { return Promise.resolve(); }} onClose={onCloseAddOpportunityModal} onDirtyChange={(dirty) => setIsDirty(dirty)} />
            </Modal>
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    onCloseAddOpportunityModal();
                    setIsConfirmationOpen(false);
                    setIsDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
            {selectedOpportunity && <SequenceModal 
                isModalOpen={selectedOpportunity !== null} 
                modalRef={modalRef} onClose={() => {
                    setSelectedOpportunity(null);
                }} 
                contact_id={selectedOpportunity?.contact?.id} 
                refresh={()=>{}} 
                owner_id={selectedOpportunity?.contact?.owner_id}
            />}
        </React.Fragment>
    );
}

export default OpportunitiesTable;
